export default __webpack_public_path__ + "static/babymoon-couple-car-36c5ef6b7ec2ecbfbedb8f3d8fa38657.jpg";